import React from "react";
import PropTypes from "prop-types";
import { Warning } from "../Filter.styles";
import Alert from "shared/components/utils/icons/Alert";

const WarningBox = ({ inline, ...props }) => {
    return (
        <Warning inline={inline}>
            <Alert size="16" viewBox="16" /> {props.children}
        </Warning>
    );
};

WarningBox.propTypes = {
    inline: PropTypes.bool,
    children: PropTypes.node,
};

export default WarningBox;
